/* ==============================================================================================
 * REDRAW TABBED TABLES
 *
 * Fix drawing issue on tables inside tabbed components.
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var tabbedInstances = document.querySelectorAll("[data-plugin=Tabbed]");

	if (!tabbedInstances) {
		return;
	}

	Sushi.Dom.forEach(tabbedInstances, function (tabbed) {
		var tabbedItems = tabbed.querySelectorAll(".c-tabbed__navItem");

		Sushi.Events(tabbedItems).on("Tabbed.tabClick", function () {
			// Resizing the window will effectivelly redraw the tables inside this tab
			Sushi.Util.triggerWindowResize();
		});
	});

})(Sushi || (Sushi = {}));
